import React from "react";
import ModalFormChoice from "./ModalFormChoice";
import "./ModalBox.scss";

const ModalBox = (props) => {
  const { title, text, formsArray } = props.toolBox;

  const titleContainer = {
    padding: "20px 20px 30px 20px",
  };

  const tipTitle = {
    textDecoration: "underline",
    fontSize: "22px",
    fontFamily: "Source Sans Pro",
  };

  const tipDescription = {
    marginTop: "20px",
  };

  const ModalSubBoxes = formsArray.map((form, index) => (
    <ModalFormChoice {...form} key={index} />
  ));

  return (
    <div className="box-container">
      <div style={titleContainer}>
        <div style={tipTitle}>{title}</div>
        <div style={tipDescription}>{text}</div>
      </div>

      {ModalSubBoxes}
    </div>
  );
};

export default ModalBox;
